import { Box, Typography, useTheme } from "@mui/material";

const SurveyStepperBar = ({ sections, activeSectionId }) => {
  const { palette } = useTheme();
  const activeIndex = (sections || []).findIndex(
    ({ id }) => id === activeSectionId
  );

  return (
    <Box display="flex" gap={1} flexGrow={1} alignItems="stretch">
      {(sections || []).map((section, idx) => {
        const isComplete = activeIndex >= 0 && idx < activeIndex;
        const isActive = activeIndex >= 0 && idx === activeIndex;
        const segmentBg = (() => {
          if (isComplete) {
            return palette.secondary.main;
          }
          if (isActive) {
            return palette.primary.main;
          }
          return palette.backgroundGray.main;
        })();
        const labelColor = (() => {
          if (isComplete || isActive) {
            return palette.common.white;
          }
          return palette.text.secondary;
        })();
        return (
          <Box
            key={section.id}
            flex="1 1 0"
            minWidth={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            px={1}
            py={0.5}
            sx={{
              borderRadius: "12px",
              backgroundColor: segmentBg,
              transition: "background-color 250ms ease"
            }}
          >
            <Typography
              variant="caption"
              noWrap
              sx={{
                color: labelColor,
                fontWeight: isActive ? 600 : 400
              }}
            >
              {`${idx + 1}. ${section.label}`}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default SurveyStepperBar;
